import { TFunction } from 'i18next'
import React from 'react'
import SsoProxyRestService from '../rest/SsoProxyRestService'
import { saveAs } from 'file-saver'


class SsoProxyService {
  static async getConfigurationStatus() {
    return SsoProxyRestService.getConfigurationStatus()
  }

  static async getGatewayIssuerConfiguration() {
    return SsoProxyRestService.getGatewayIssuerConfiguration()
  }

  static async getSupportedSignatureAlgorithms() {
    return SsoProxyRestService.getSupportedSignatureAlgorithms()
  }

  static async setGatewayIssuerConfiguration(
    config: any,
    t: TFunction,
    setGatewayIssuerConfig: React.Dispatch<any>,
    setConfigurationStatus: React.Dispatch<any>
  ) {
    try {
      await SsoProxyRestService.setGatewayIssuerConfiguration(config)
      const issuerConfig = await SsoProxyService.getGatewayIssuerConfiguration()
      setGatewayIssuerConfig(issuerConfig)
      const configStatus = await SsoProxyService.getConfigurationStatus()
      setConfigurationStatus(configStatus)
      return t('ssoProxy.gatewayIssuerConfigSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getGatewayCertificates() {
    return SsoProxyRestService.getGatewayCertificates()
  }

  static async generateGatewayCertificates(t: TFunction, setGatewayCertificates: React.Dispatch<any>) {
    try {
      await SsoProxyRestService.generateGatewayCertificates()
      const certificates = await SsoProxyService.getGatewayCertificates()
      setGatewayCertificates(certificates)
      return t('ssoProxy.generateGatewayCertificateSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getRewritingRules() {
    return SsoProxyRestService.getRewritingRules()
  }

  static async createRewritingRules(rule: any, t: TFunction, setRewritingRules: React.Dispatch<any>) {
    try {
      await SsoProxyRestService.createRewritingRules(rule)
      const rewritingRules = await SsoProxyService.getRewritingRules()
      setRewritingRules(rewritingRules)
      return t('ssoProxy.rewritingRulesCreateSucess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async updateRewritingRules(rule: any, t: TFunction, setRewritingRules: React.Dispatch<any>) {
    try {
      await SsoProxyRestService.updateRewritingRules(rule)
      const rewritingRules = await SsoProxyService.getRewritingRules()
      setRewritingRules(rewritingRules)
      return t('ssoProxy.rewritingRulesCreateSucess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async deleteRewritingRules(id: any, t: TFunction, setRewritingRules: React.Dispatch<any>) {
    try {
      await SsoProxyRestService.deleteRewritingRules(id)
      const rewritingRules = await SsoProxyService.getRewritingRules()
      setRewritingRules(rewritingRules)
      return t('ssoProxy.rewritingRulesDeleteSucess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getTargetIdPInfo() {
    return SsoProxyRestService.getTargetIdPInfo()
  }

  static async uploadIdPMetadata(data: any, t: TFunction, setIdpConfig: React.Dispatch<any>, setConfigurationStatus: any) {
    try {
      const formData = new FormData()
      formData.append('idPMetadata', data.idPMetadata)
      await SsoProxyRestService.uploadIdPMetadata(formData)

      const idpInfo = await SsoProxyService.getTargetIdPInfo()
      setIdpConfig(idpInfo)

      const config = await SsoProxyService.getConfigurationStatus()
      setConfigurationStatus(config)
      return t('ssoProxy.idpMetadaUploadSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async downloadGatewayIdPMetadata() {
    try {
      const idpMetada = await SsoProxyRestService.downloadGatewayIdPMetadata()
      saveAs(idpMetada, 'GatewayIdPMetadata.xml')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async getTargetSPInfo() {
    return SsoProxyRestService.getTargetSPInfo()
  }

  static async uploadSPMetadata(data: any, t: TFunction, setSpConfig: React.Dispatch<any>, setConfigurationStatus: any) {
    try {
      const formData = new FormData()
      formData.append('spMetadata', data.spMetadata)
      await SsoProxyRestService.uploadSPMetadata(formData)

      const spInfo = await SsoProxyService.getTargetSPInfo()
      setSpConfig(spInfo)

      const config = await SsoProxyService.getConfigurationStatus()
      setConfigurationStatus(config)
      return t('ssoProxy.spMetadaUploadSuccess')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static async downloadGatewaySPMetadata() {
    try {
      const idpMetada = await SsoProxyRestService.downloadGatewaySPMetadata()
      saveAs(idpMetada, 'GatewayServiceProviderMetadata.xml')
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default SsoProxyService
